const SCRIPTS = {
        WELCOME: 'Hey! Great to have you here.<br/>  What can I help you with today?',
        WELCOME_BACK: 'Hey! Great to have you back :)<br/>  What can I help you with today?',
        SELECT_ACCOUNT: 'Just choose a connection for which you want to talk about.',
        LOGIN_SUCCESS: 'Great! You have successfully logged-in',
        SKIP_MESSAGE: 'Please type in your new query.',
        DEFAULT_ERROR: 'Ooops.. something went wrong!',
        PLAN_CHANGE_SUCCESS: 'You request for plan change is under process and will take 2 hours to complete. Don’t worry, an SMS confirmation will be sent once the plan change request is completed.',
        PLAN_CHANGE_FAIL: 'Uh-oh ! Your request for plan change could not be completed successfully. Please retry.',
        PAYMENT_SUCCESS: `Yay ! Your transaction was successful. Here are your payment details:<br>
                                Mobile Number: {mobile}
                                Amount Paid: Rs {amount}
                                Transaction Id: {transactionId}
                                Transaction Date: {transactionDate}`,
        PAYMENT_FAIL: `Uh-oh ! Your payment could not be completed successfully. Please retry.`,
        PAYMENT_PENDING: 'Your payment is under process. Don’t worry, an SMS confirmation will be sent once the payment is done.',
        EXCEPTION_REPLACED_MESSAGE: 'Oops, I am not able to process your request at this moment. You can connect to our Airtel friends at 121.',
        NO_SYSTEM_INFO_MESSAGE: ' Oops, I am not able to find this information at this moment. You can connect with our Airtel friends at 121.',
        NO_BILLS: 'This is to inform you that there are  no previous bills on your account.',
        NO_RECEIPTS: 'This is to inform you that there are no previous receipts on your account.',
        SR_RAISED_SUCCESSFULLY:'I have registered your complaint via service request no. ',
        LOB_SPECIFIC_NO_RESOLUTION_VOC:"I'm sorry! I'm unable to provide resolution to your queries for {LOB} connection at the moment.",
        LOGIN_FAILED_PLEASE_RELOGIN:"Hey! while I’m learning about other businesses I can currently answer Postpaid related queries. Please login with a Postpaid number."
}
export { SCRIPTS }


// WEBPACK FOOTER //
// ./src/constants/staticScripts.js